module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading01-pc-2fcabd1d6cde74d77d17386a09855bf3.png";